<header>
	<nav>
		<a routerLink="/">
			@if (!configService.isPreregister()) {
			<span i18n="@@landing.nav.preregistration">Inscription</span>
			} @else {
			<span i18n="@@landing.nav.registration">Pré-inscription</span>
			}
			<span class="mos-line"></span>
		</a>
		<a routerLink="/story">
			<span i18n="@@landing.nav.story">L'histoire</span>
			<span class="mos-line"></span>
		</a>
		<a routerLink="/npcs">
			<span i18n="@@landing.nav.npcs">Les personnages</span>
			<span class="mos-line"></span>
		</a>
		<a routerLink="/game">
			<span i18n="@@landing.nav.game">Le jeu</span>
			<span class="mos-line"></span>
		</a>
		<a routerLink="/team">
			<span i18n="@@landing.nav.team">L'équipe</span>
			<span class="mos-line"></span>
		</a>
		<a routerLink="/faq">
			<span i18n="@@landing.nav.faq"> FAQ</span>
			<span class="mos-line"></span>
		</a>

		<mos-social-links></mos-social-links>
	</nav>

	<mos-landing-burger-menu></mos-landing-burger-menu>
</header>

<main>
	<router-outlet></router-outlet>
</main>

<footer>
	<div class="mos-landing-container">
		<div>© {{ configService.getCopyrightYear() }} - {{ configService.getDisplayName() }}</div>
		<div class="footer-nav">
			<a class="no-visited" routerLink="/legal/credits" i18n="@@landing.footer.nav.legal.credits">Crédits</a>
			<a class="no-visited" routerLink="/legal/conditions" i18n="@@landing.footer.nav.legal/conditions">CGU</a>
			<a class="no-visited" routerLink="/legal/notices" i18n="@@landing.footer.nav.legal.notices"
				>Mentions légales</a
			>
			<a class="no-visited" routerLink="/legal/privacy" i18n="@@landing.footer.nav.legal.privacy"
				>Politique de confidentialité</a
			>
			<a class="no-visited" routerLink="/legal/fan-arts-policy" i18n="@@landing.footer.nav.legal.videos"
				>Politique relative au contenu de fan</a
			>
			<a class="no-visited" routerLink="/legal/cookies" i18n="@@landing.footer.nav.legal.cookies"
				>Politique relative aux cookies</a
			>
			<a href="javascript:Cookiebot.renew()" class="option">
				<span i18n="@@options.option.cookies">Paramétrage des cookies</span>
			</a>
		</div>
	</div>
</footer>

@defer (on idle) {
<mos-landing-authentication-modal
	[(opened)]="landingService.authenticationModalVisible"
	[authenticationForm]="landingService.authenticationModalConfig()"
></mos-landing-authentication-modal>
<mos-pre-registration-complete-modal
	[(opened)]="landingService.preregistrationCompleteModalVisible"
></mos-pre-registration-complete-modal>
}
